import { formatDateValue } from '../../grid/components/data-display/utils';

export const formatDate = (value?: string | null) => {
  if (!value) return 'Unresolved';
  return formatDateValue(value, 'utc').split(',')[0] || value;
};

export const formatSourcePeriod = (from?: string | null, to?: string | null) => {
  if (!from && !to) return 'Unresolved';
  return `${formatDate(from)} - ${formatDate(to)}`;
};

export const valueOrUnresolved = (value?: string | number | null) =>
  value == null || value === '' ? 'Unresolved' : String(value);

export const nullableNumber = (value: string) => {
  if (value.trim() === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const formatNumber = (value?: number | null) =>
  value == null || !Number.isFinite(value) ? 'Unresolved' : String(value);

export const ellipsisTextFieldSx = {
  '& .MuiInputBase-input': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};
